import { Box, Button, Chip, Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import ScienceIcon from "@mui/icons-material/Science";
import SecurityIcon from "@mui/icons-material/Security";
import SelexSolNavbar from "./CommonC/SelexSolNavbar";

import SelexMB from "../images/SelexMB Final.png";
import SelexSIM from "../images/SelexSIM.png";
import SelexRISK from "../images/SelexRISK.png";

const primary = "#0078c9";
const accent = "#9e0b22";
const navy = "#061d34";

const modules = [
  {
    name: "SelexMB™",
    title: "AI-Driven Operations",
    img: SelexMB,
    icon: <AutoAwesomeIcon />,
    route: "/selexmblanding",
    tag: "AI + ML Operations",
    shortDesc: "Autonomous AI-based operations for smarter, greener, and more efficient energy systems.",
    desc: `Revolutionizing AI-Driven Operations in the Energy Sector.

SelexMB™ is a cutting-edge software solution that empowers energy companies to harness artificial intelligence and machine learning for enhanced decision-making and operational efficiency.

Designed as a SaaS application, SelexMB™ includes ML, ANN, and hybrid modeling capabilities that integrate first principles with AI-driven insights. Fully compatible with Aspen HYSYS and AspenOnline, it supports autonomous AI-based operations, process optimization, emission reduction, and sustainability projects.`,
  },
  {
    name: "SelexSIM™",
    title: "Simulation Intelligence",
    img: SelexSIM,
    icon: <ScienceIcon />,
    route: "/selexsimlanding",
    tag: "Modeling + Optimization",
    shortDesc: "Advanced mathematical modeling and simulation tools for next-generation energy solutions.",
    desc: `Advanced Mathematical Modeling for Next-Generation Energy Solutions.

SelexSIM™ simplifies and accelerates mathematical modeling for the energy sector. It bridges complex engineering challenges with actionable insights, helping organizations innovate and optimize with confidence.

The platform supports Lean Model Dynamics, discrete and stochastic systems, real-time analysis, process monitoring, and optimization workflows for R&D, engineering, and operations teams.`,
  },
  {
    name: "SelexRISK™",
    title: "Risk & Safety Intelligence",
    img: SelexRISK,
    icon: <SecurityIcon />,
    route: "/selectselexrisk",
    tag: "Risk + Reliability",
    shortDesc: "Process safety, risk management, reliability, and hazard analysis for safer operations.",
    desc: `Comprehensive Risk Management and Process Safety Analysis.

SelexRISK™ advances risk management and process safety across complex energy operations by streamlining hazard identification, analysis, mitigation planning, and decision support.

It supports PHA, root cause analysis, vulnerability assessment, safeguard evaluation, consequence modeling, risk matrices, severity analysis, and post-mitigation evaluation for safer and more resilient operations.`,
  },
];

const Select = () => {
  const navigate = useNavigate();
  const [active, setActive] = useState("SelexMB™");

  const activeModule = modules.find((item) => item.name === active) || modules[0];

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background:"fff",
        overflowX: "hidden",
        position: "relative",
      }}
    >
      <SelexSolNavbar isLoggedIn={!!sessionStorage.getItem("usertoken")}/>

      <Box
        sx={{
          width: "min(1180px, calc(100% - 32px))",
          mx: "auto",
          pt: { xs: 1, md: 2 },
          pb: 8,
        }}
      >
        {/* ONLY Module SECTION */}
        <Box sx={{ textAlign: "center", mb: 5 }} id="modules">
          <Typography
            sx={{
              color: accent,
              fontSize: 12,
              fontWeight: 950,
              letterSpacing: 1.4,
              textTransform: "uppercase",
              mb: 1,
            }}
          >
            Modules
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: 30, md: 46 },
              fontWeight: 950,
              color: navy,
              letterSpacing: "-1.6px",
              mb: 1.5,
            }}
          >
            Choose a <Box component="span" sx={{ color: primary }}>Selex<span style={{ color: "#9e0b22" }}>Suite™</span></Box> Module
          </Typography>

          <Typography
            sx={{
              color: "#64748b",
              maxWidth: 740,
              mx: "auto",
              lineHeight: 1.75,
              fontSize: 15,
            }}
          >
            Select the platform that matches your engineering objective — AI operations, process simulation, or risk intelligence.
          </Typography>
        </Box>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
            gap: 3,
          }}
        >
          {modules.map((item, index) => (
            <Box
              key={item.name}
              onMouseEnter={() => setActive(item.name)}
              onClick={() => setActive(item.name)}
              sx={{
                cursor: "pointer",
                position: "relative",
                minHeight: 390,
                p: 3.2,
                borderRadius: "32px",
                background: "rgba(255,255,255,0.92)",
                backdropFilter: "blur(18px)",
                overflow: "hidden",
                border:
                  active === item.name
                    ? `2px solid ${primary}`
                    : "1px solid rgba(0,120,201,0.13)",
                boxShadow:
                  active === item.name
                    ? "0 28px 70px rgba(0,120,201,0.18)"
                    : "0 18px 50px rgba(6,29,52,0.08)",
                transform: active === item.name ? "translateY(-8px)" : "translateY(0)",
                transition: "0.35s ease",
                "&:hover": {
                  transform: "translateY(-10px)",
                  boxShadow: "0 30px 75px rgba(0,120,201,0.18)",
                  borderColor: primary,
                },
                
              }}
            >
              <Box sx={{ position: "relative", zIndex: 2 }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 3 }}>
                  <Box
                    sx={{
                      width: 88,
                      height: 88,
                      borderRadius: "26px",
                      background: "linear-gradient(135deg, #ffffff, #f4f9ff)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 16px 38px rgba(6,29,52,0.10)",
                      border: "1px solid rgba(0,120,201,0.10)",
                    }}
                  >
                    <Box component="img" src={item.img} alt={item.name} sx={{ width: 68, maxHeight: 68, objectFit: "contain" }} />
                  </Box>

                
                </Box>

                <Chip
                  label={item.tag}
                  size="small"
                  sx={{
                    bgcolor: active === item.name ? "rgba(0,120,201,0.10)" : "rgba(158,11,34,0.07)",
                    color: active === item.name ? primary : accent,
                    border: active === item.name ? "1px solid rgba(0,120,201,0.18)" : "1px solid rgba(158,11,34,0.12)",
                    fontWeight: 900,
                    mb: 2,
                  }}
                />

                <Typography sx={{ fontSize: 26, fontWeight: 950, color: navy, mb: 1 }}>
                  {item.name}
                </Typography>

                <Typography sx={{ fontSize: 15, fontWeight: 800, color: primary, mb: 1.5 }}>
                  {item.title}
                </Typography>

                <Typography sx={{ fontSize: 14, color: "#64748b", lineHeight: 1.8, mb: 3 }}>
                  {item.shortDesc}
                </Typography>

                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(item.route);
                  }}
                  endIcon={<ArrowForwardIcon />}
                  sx={{
                    mt: 1,
                    px: 2.4,
                    py: 1.15,
                    borderRadius: "999px",
                    textTransform: "none",
                    fontWeight: 900,
                    fontSize:14,
                    color: active === item.name ? "#fff" : "#fff",
                    background:"#0078c9",
                    boxShadow: active === item.name ? "0 14px 30px rgba(0,120,201,0.24)" : "none",
                    "&:hover": {
                      color: "#fff",
                      background: accent,
                      transform: "translateY(-2px)",
                    },
                  }}
                >
                  Select Module
                </Button>
              </Box>
            </Box>
          ))}
        </Box>

        {/* DYNAMIC OVERVIEW BOX */}
        <Box
          sx={{
            mt: 4,
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "0.8fr 1.2fr" },
            gap: 3,
            alignItems: "stretch",
          }}
        >
          <Box
            sx={{
              p: { xs: 3, md: 4 },
              borderRadius: "32px",
              background: "#fff",
              border: "1px solid rgba(0,120,201,0.14)",
              boxShadow: "0 18px 50px rgba(6,29,52,0.08)",
              position: "relative",
              overflow: "hidden",
              "&:before": {
                content: '""',
                position: "absolute",
                width: 190,
                height: 190,
                right: -70,
                top: -70,
                borderRadius: "50%",
                background: "radial-gradient(circle, rgba(0,120,201,0.12), transparent 68%)",
              },
            }}
          >
            <Box sx={{ position: "relative", zIndex: 2 }}>
              <Typography sx={{ color: accent, fontSize: 12, fontWeight: 950, letterSpacing: 1.2, textTransform: "uppercase", mb: 1 }}>
                Selected Module
              </Typography>

              <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2.5 }}>
                <Box
                  sx={{
                    width: 82,
                    height: 82,
                    borderRadius: "24px",
                    background: "linear-gradient(135deg, #ffffff, #f4f9ff)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 14px 34px rgba(6,29,52,0.10)",
                    border: "1px solid rgba(0,120,201,0.10)",
                  }}
                >
                  <Box component="img" src={activeModule.img} alt={activeModule.name} sx={{ width: 62, maxHeight: 62, objectFit: "contain" }} />
                </Box>

                <Box>
                  <Typography sx={{ color: navy, fontSize: { xs: 28, md: 36 }, fontWeight: 950, lineHeight: 1 }}>
                    {activeModule.name}
                  </Typography>
                  <Typography sx={{ color: primary, fontSize: 15, fontWeight: 900, mt: 0.8 }}>
                    {activeModule.title}
                  </Typography>
                </Box>
              </Box>

              <Chip
                label={activeModule.tag}
                sx={{
                  bgcolor: "rgba(158,11,34,0.08)",
                  color: accent,
                  border: "1px solid rgba(158,11,34,0.13)",
                  fontWeight: 900,
                  mb: 2.5,
                }}
              />
              <br />

              <Button sx={{fontSize:14}} onClick={() => navigate(activeModule.route)} endIcon={<ArrowForwardIcon />} sx={primaryBtn}>
                Continue to {activeModule.name}
              </Button>
            </Box>
          </Box>

          <Box
            sx={{
              p: { xs: 3, md: 4 },
              borderRadius: "32px",
              background: navy,
              color: "#fff",
              border: "1px solid rgba(0,120,201,0.16)",
              boxShadow: "0 24px 65px rgba(6,29,52,0.16)",
              position: "relative",
              overflow: "hidden",
              "&:before": {
                content: '""',
                position: "absolute",
                width: 220,
                height: 220,
                right: -80,
                top: -80,
                borderRadius: "50%",
                background: "radial-gradient(circle, rgba(0,120,201,0.36), transparent 68%)",
              },
              "&:after": {
                content: '""',
                position: "absolute",
                width: 170,
                height: 170,
                left: -65,
                bottom: -65,
                borderRadius: "50%",
                background: "radial-gradient(circle, rgba(158,11,34,0.32), transparent 68%)",
              },
            }}
          >
            <Box sx={{ position: "relative", zIndex: 2 }}>
              <Typography sx={{ color: "#9bd7ff", fontSize: 12, fontWeight: 950, letterSpacing: 1.2, textTransform: "uppercase", mb: 1 }}>
                Overview
              </Typography>

              <Typography sx={{ color: "#fff", fontSize: { xs: 24, md: 32 }, fontWeight: 950, mb: 2, letterSpacing: "-0.8px" }}>
                {activeModule.title}
              </Typography>

              <Typography
                sx={{
                  color: "rgba(255,255,255,0.74)",
                  whiteSpace: "pre-line",
                  lineHeight: 1.85,
                  fontSize: 14,
                }}
              >
                {activeModule.desc}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const primaryBtn = {
  px: 3,
  py: 1.35,
  borderRadius: "999px",
  background: "#0078c9",
  color: "#fff",
  fontWeight: 900,
  fontSize:14,
  textTransform: "none",
  boxShadow: "0 14px 34px rgba(0,120,201,0.28)",
  "&:hover": {
    background: `linear-gradient(135deg, ${accent}, #75081a)`,
    transform: "translateY(-2px)",
    boxShadow: "0 18px 40px rgba(158,11,34,0.28)",
  },
};

const outlineBtn = {
  px: 3,
  py: 1.35,
  borderRadius: "999px",
  color: primary,
  fontWeight: 900,
  textTransform: "none",
  background: "#fff",
  border: "1px solid rgba(0,120,201,0.25)",
  "&:hover": {
    color: accent,
    borderColor: accent,
    background: "rgba(158,11,34,0.04)",
    transform: "translateY(-2px)",
  },
};

export default Select;
